import { appPath } from '../../routes/paths';
import {
  SETUP_CATEGORIES_LABEL,
  SETUP_SEGMENTS_LABEL,
  SETUP_NAV_LABEL,
  SETUP_STAGES_LABEL,
} from './setup/copy';

export const SETUP_BASE_PATH = '/setup';

export const SETUP_CHILD_ROUTES = [
  {
    path: 'lead-pipeline-stages',
    label: SETUP_STAGES_LABEL,
    permission: 'lead-pipeline-stages.view',
  },
  {
    path: 'customer-segments',
    label: SETUP_SEGMENTS_LABEL,
    permission: 'customer-segments.view',
  },
  {
    path: 'contact-categories',
    label: SETUP_CATEGORIES_LABEL,
    permission: 'contact-categories.view',
  },
] as const;

export type SetupChildPath = (typeof SETUP_CHILD_ROUTES)[number]['path'];

export function setupPath(subpath?: SetupChildPath): string {
  if (subpath === undefined) {
    return appPath(SETUP_BASE_PATH);
  }
  return appPath(`${SETUP_BASE_PATH}/${subpath}`);
}

export function canAccessSetup(hasPermission: (permission: string) => boolean): boolean {
  return SETUP_CHILD_ROUTES.some((route) => hasPermission(route.permission));
}

export function getFirstAllowedSetupPath(
  hasPermission: (permission: string) => boolean,
): string | null {
  for (const route of SETUP_CHILD_ROUTES) {
    if (hasPermission(route.permission)) {
      return setupPath(route.path);
    }
  }
  return null;
}

export function getSetupNavLabel(pathname: string): string | null {
  const setupBase = appPath(SETUP_BASE_PATH);
  const match = SETUP_CHILD_ROUTES.find(
    (route) =>
      pathname === `${setupBase}/${route.path}` ||
      pathname.startsWith(`${setupBase}/${route.path}/`),
  );
  return (
    match?.label
    ?? (pathname === setupBase || pathname.startsWith(`${setupBase}/`) ? SETUP_NAV_LABEL : null)
  );
}
